/**
 * NWT_Core_Services
 * <h1>NWT_Core_Services</h1>
 *
 * OpenAPI spec version:
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { JsonAccount } from '../model/jsonAccount';
import { JsonAccountDevice } from '../model/jsonAccountDevice';
import { JsonAccountExclusion } from '../model/jsonAccountExclusion';
import { JsonAccountList } from '../model/jsonAccountList';
import { JsonAccountToMacResultsList } from '../model/jsonAccountToMacResultsList';
import { JsonActiveEventCountStormModeAndThresholdResponse } from '../model/jsonActiveEventCountStormModeAndThresholdResponse';
import { JsonAdvancedSearchResult } from '../model/jsonAdvancedSearchResult';
import { JsonAutoTicketingInfo } from '../model/jsonAutoTicketingInfo';
import { JsonBaseResponseDTO } from '../model/jsonBaseResponseDTO';
import { JsonCmtsInitialMapping } from '../model/jsonCmtsInitialMapping';
import { JsonEventDetailsListDTO } from '../model/jsonEventDetailsListDTO';
import { JsonExcludedTransponderInfo } from '../model/jsonExcludedTransponderInfo';
import { JsonInputParam } from '../model/jsonInputParam';
import { JsonJobTsi } from '../model/jsonJobTsi';
import { JsonMenuDTO } from '../model/jsonMenuDTO';
import { JsonMismatchDeviceInfo } from '../model/jsonMismatchDeviceInfo';
import { JsonNearNeighborAccount } from '../model/jsonNearNeighborAccount';
import { JsonNodeLog } from '../model/jsonNodeLog';
import { JsonNodeLogEntry } from '../model/jsonNodeLogEntry';
import { JsonNodeMoveHistory } from '../model/jsonNodeMoveHistory';
import { JsonNodeNDTicket } from '../model/jsonNodeNDTicket';
import { JsonNodeProximityList } from '../model/jsonNodeProximityList';
import { JsonNodeSMTicket } from '../model/jsonNodeSMTicket';
import { JsonNodeScoreInfo } from '../model/jsonNodeScoreInfo';
import { JsonNodeSearchResultsList } from '../model/jsonNodeSearchResultsList';
import { JsonNodeSubscribersDTO } from '../model/jsonNodeSubscribersDTO';
import { JsonNodeTransponderResponse } from '../model/jsonNodeTransponderResponse';
import { JsonNoiseLog } from '../model/jsonNoiseLog';
import { JsonPoweredNode } from '../model/jsonPoweredNode';
import { JsonRTMRepairLog } from '../model/jsonRTMRepairLog';
import { JsonRTMRepairLogInfo } from '../model/jsonRTMRepairLogInfo';
import { JsonSaveTSIAffectedAccountsReq } from '../model/jsonSaveTSIAffectedAccountsReq';
import { JsonSystemMapFtaId } from '../model/jsonSystemMapFtaId';
import { JsonTransponderInfo } from '../model/jsonTransponderInfo';
import { JsonTransponderInventory } from '../model/jsonTransponderInventory';
import { JsonTransponderTrackerResult } from '../model/jsonTransponderTrackerResult';
import { JsonWorstNode } from '../model/jsonWorstNode';

import { NWT_BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class NodeServiceResourceService {

    protected basePath = 'https://localhost/corejson';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(NWT_BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (let consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     *
     *
     * @param body
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public resourceNodeServiceResourceAddNodeLogPOST(body?: JsonNodeLogEntry, observe?: 'body', reportProgress?: boolean): Observable<JsonBaseResponseDTO>;
    public resourceNodeServiceResourceAddNodeLogPOST(body?: JsonNodeLogEntry, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<JsonBaseResponseDTO>>;
    public resourceNodeServiceResourceAddNodeLogPOST(body?: JsonNodeLogEntry, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<JsonBaseResponseDTO>>;
    public resourceNodeServiceResourceAddNodeLogPOST(body?: JsonNodeLogEntry, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/xml',
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/xml',
            'application/json'
        ];
        let httpContentTypeSelected:string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set("Content-Type", httpContentTypeSelected);
        }

        return this.httpClient.post<JsonBaseResponseDTO>(`${this.basePath}/nodeService/addNodeLog`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Adds noise log.
     * Adds noise log
     * @param body
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public resourceNodeServiceResourceAddNoiseLogPOST(body?: JsonNoiseLog, observe?: 'body', reportProgress?: boolean): Observable<Array<JsonNoiseLog>>;
    public resourceNodeServiceResourceAddNoiseLogPOST(body?: JsonNoiseLog, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<JsonNoiseLog>>>;
    public resourceNodeServiceResourceAddNoiseLogPOST(body?: JsonNoiseLog, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<JsonNoiseLog>>>;
    public resourceNodeServiceResourceAddNoiseLogPOST(body?: JsonNoiseLog, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/xml',
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/xml',
            'application/json'
        ];
        let httpContentTypeSelected:string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set("Content-Type", httpContentTypeSelected);
        }

        return this.httpClient.post<Array<JsonNoiseLog>>(`${this.basePath}/nodeService/addNoiseLog`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * This is the web method to perform advanced search of node , mac , account number , phone number or adddress.
     * This is the web method to perform advanced search of node , mac , account number , phone number or adddress.
     * @param text is the to be searched item in string format
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public resourceNodeServiceResourceAdvancedSearchGET(text?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<JsonAdvancedSearchResult>>;
    public resourceNodeServiceResourceAdvancedSearchGET(text?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<JsonAdvancedSearchResult>>>;
    public resourceNodeServiceResourceAdvancedSearchGET(text?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<JsonAdvancedSearchResult>>>;
    public resourceNodeServiceResourceAdvancedSearchGET(text?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (text !== undefined) {
            queryParameters = queryParameters.set('text', <any>text);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/xml',
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
        ];

        return this.httpClient.get<Array<JsonAdvancedSearchResult>>(`${this.basePath}/nodeService/advancedSearch`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public resourceNodeServiceResourceArchiveNodeMovesGET(observe?: 'body', reportProgress?: boolean): Observable<string>;
    public resourceNodeServiceResourceArchiveNodeMovesGET(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<string>>;
    public resourceNodeServiceResourceArchiveNodeMovesGET(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<string>>;
    public resourceNodeServiceResourceArchiveNodeMovesGET(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/xml',
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
        ];

        return this.httpClient.get<string>(`${this.basePath}/nodeService/archiveNodeMoves`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param body
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public resourceNodeServiceResourceExcludeTransponderPOST(body?: Array<JsonExcludedTransponderInfo>, observe?: 'body', reportProgress?: boolean): Observable<number>;
    public resourceNodeServiceResourceExcludeTransponderPOST(body?: Array<JsonExcludedTransponderInfo>, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<number>>;
    public resourceNodeServiceResourceExcludeTransponderPOST(body?: Array<JsonExcludedTransponderInfo>, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<number>>;
    public resourceNodeServiceResourceExcludeTransponderPOST(body?: Array<JsonExcludedTransponderInfo>, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/xml',
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/xml',
            'application/json'
        ];
        let httpContentTypeSelected:string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set("Content-Type", httpContentTypeSelected);
        }

        return this.httpClient.post<number>(`${this.basePath}/nodeService/excludeTransponder`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * This WebMethod  will  returns a list of Accounts for a Node.
     * This WebMethod  will  returns a list of Accounts for a Node
     * @param CMTS
     * @param node
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public resourceNodeServiceResourceGetAccountsForANodeGET(CMTS?: string, node?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<JsonAccountDevice>>;
    public resourceNodeServiceResourceGetAccountsForANodeGET(CMTS?: string, node?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<JsonAccountDevice>>>;
    public resourceNodeServiceResourceGetAccountsForANodeGET(CMTS?: string, node?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<JsonAccountDevice>>>;
    public resourceNodeServiceResourceGetAccountsForANodeGET(CMTS?: string, node?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (CMTS !== undefined) {
            queryParameters = queryParameters.set('CMTS', <any>CMTS);
        }
        if (node !== undefined) {
            queryParameters = queryParameters.set('node', <any>node);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/xml',
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
        ];

        return this.httpClient.get<Array<JsonAccountDevice>>(`${this.basePath}/nodeService/getAccountsForANode`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param cmts
     * @param nodeName
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public resourceNodeServiceResourceGetActiveEventCountStormModeAndThresholdsGET(cmts?: string, nodeName?: string, observe?: 'body', reportProgress?: boolean): Observable<JsonActiveEventCountStormModeAndThresholdResponse>;
    public resourceNodeServiceResourceGetActiveEventCountStormModeAndThresholdsGET(cmts?: string, nodeName?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<JsonActiveEventCountStormModeAndThresholdResponse>>;
    public resourceNodeServiceResourceGetActiveEventCountStormModeAndThresholdsGET(cmts?: string, nodeName?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<JsonActiveEventCountStormModeAndThresholdResponse>>;
    public resourceNodeServiceResourceGetActiveEventCountStormModeAndThresholdsGET(cmts?: string, nodeName?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (cmts !== undefined) {
            queryParameters = queryParameters.set('cmts', <any>cmts);
        }
        if (nodeName !== undefined) {
            queryParameters = queryParameters.set('nodeName', <any>nodeName);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/xml',
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
        ];

        return this.httpClient.get<JsonActiveEventCountStormModeAndThresholdResponse>(`${this.basePath}/nodeService/getActiveEventCountStormModeAndThresholds`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public resourceNodeServiceResourceGetAllExcludedAccountsGET(observe?: 'body', reportProgress?: boolean): Observable<Array<JsonAccountExclusion>>;
    public resourceNodeServiceResourceGetAllExcludedAccountsGET(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<JsonAccountExclusion>>>;
    public resourceNodeServiceResourceGetAllExcludedAccountsGET(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<JsonAccountExclusion>>>;
    public resourceNodeServiceResourceGetAllExcludedAccountsGET(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/xml',
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
        ];

        return this.httpClient.get<Array<JsonAccountExclusion>>(`${this.basePath}/nodeService/getAllExcludedAccounts`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public resourceNodeServiceResourceGetCMTSInitialToNCPServiceTypeMappingGET(observe?: 'body', reportProgress?: boolean): Observable<JsonCmtsInitialMapping>;
    public resourceNodeServiceResourceGetCMTSInitialToNCPServiceTypeMappingGET(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<JsonCmtsInitialMapping>>;
    public resourceNodeServiceResourceGetCMTSInitialToNCPServiceTypeMappingGET(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<JsonCmtsInitialMapping>>;
    public resourceNodeServiceResourceGetCMTSInitialToNCPServiceTypeMappingGET(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/xml',
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
        ];

        return this.httpClient.get<JsonCmtsInitialMapping>(`${this.basePath}/nodeService/cmtsInitialToNcpServiceTypeMapping`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * This WebMethod  will take all node name  and cmts returns a list of Transponder.
     * This WebMethod  will take all node name  and cmts returns a list of Transponder
     * @param body
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public resourceNodeServiceResourceGetEventsForAllNodePOST(body?: JsonInputParam, observe?: 'body', reportProgress?: boolean): Observable<JsonEventDetailsListDTO>;
    public resourceNodeServiceResourceGetEventsForAllNodePOST(body?: JsonInputParam, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<JsonEventDetailsListDTO>>;
    public resourceNodeServiceResourceGetEventsForAllNodePOST(body?: JsonInputParam, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<JsonEventDetailsListDTO>>;
    public resourceNodeServiceResourceGetEventsForAllNodePOST(body?: JsonInputParam, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/xml',
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/xml',
            'application/json'
        ];
        let httpContentTypeSelected:string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set("Content-Type", httpContentTypeSelected);
        }

        return this.httpClient.post<JsonEventDetailsListDTO>(`${this.basePath}/nodeService/getEventsForAllNode`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public resourceNodeServiceResourceGetExcludedTranspondersGET(observe?: 'body', reportProgress?: boolean): Observable<Array<JsonExcludedTransponderInfo>>;
    public resourceNodeServiceResourceGetExcludedTranspondersGET(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<JsonExcludedTransponderInfo>>>;
    public resourceNodeServiceResourceGetExcludedTranspondersGET(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<JsonExcludedTransponderInfo>>>;
    public resourceNodeServiceResourceGetExcludedTranspondersGET(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/xml',
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
        ];

        return this.httpClient.get<Array<JsonExcludedTransponderInfo>>(`${this.basePath}/nodeService/getExcludedTransponders`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * This service will take an account number and return a list of mac addresses for the account.
     * This service will take an account number and return a list of mac addresses for the account
     * @param account account number
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public resourceNodeServiceResourceGetMacsByAccountNbrGET(account?: string, observe?: 'body', reportProgress?: boolean): Observable<JsonAccountToMacResultsList>;
    public resourceNodeServiceResourceGetMacsByAccountNbrGET(account?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<JsonAccountToMacResultsList>>;
    public resourceNodeServiceResourceGetMacsByAccountNbrGET(account?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<JsonAccountToMacResultsList>>;
    public resourceNodeServiceResourceGetMacsByAccountNbrGET(account?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (account !== undefined) {
            queryParameters = queryParameters.set('account', <any>account);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/xml',
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
        ];

        return this.httpClient.get<JsonAccountToMacResultsList>(`${this.basePath}/nodeService/getMacsByAccountNbr`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param cmts
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public resourceNodeServiceResourceGetMismatchDevicesOfCMTSGET(cmts?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<JsonMismatchDeviceInfo>>;
    public resourceNodeServiceResourceGetMismatchDevicesOfCMTSGET(cmts?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<JsonMismatchDeviceInfo>>>;
    public resourceNodeServiceResourceGetMismatchDevicesOfCMTSGET(cmts?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<JsonMismatchDeviceInfo>>>;
    public resourceNodeServiceResourceGetMismatchDevicesOfCMTSGET(cmts?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (cmts !== undefined) {
            queryParameters = queryParameters.set('cmts', <any>cmts);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/xml',
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
        ];

        return this.httpClient.get<Array<JsonMismatchDeviceInfo>>(`${this.basePath}/nodeService/getMismatchDevicesOfCMTS`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * This WebMethod  will  returns a list of Near Neighbor Accounts.
     * This WebMethod  will  returns a list of Near Neighbor Accounts
     * @param accountNumber
     * @param applicationKey
     * @param numberOfAccounts
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public resourceNodeServiceResourceGetNearNeighborAccountsGET(accountNumber?: string, applicationKey?: string, numberOfAccounts?: number, observe?: 'body', reportProgress?: boolean): Observable<JsonNearNeighborAccount>;
    public resourceNodeServiceResourceGetNearNeighborAccountsGET(accountNumber?: string, applicationKey?: string, numberOfAccounts?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<JsonNearNeighborAccount>>;
    public resourceNodeServiceResourceGetNearNeighborAccountsGET(accountNumber?: string, applicationKey?: string, numberOfAccounts?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<JsonNearNeighborAccount>>;
    public resourceNodeServiceResourceGetNearNeighborAccountsGET(accountNumber?: string, applicationKey?: string, numberOfAccounts?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (accountNumber !== undefined) {
            queryParameters = queryParameters.set('accountNumber', <any>accountNumber);
        }
        if (applicationKey !== undefined) {
            queryParameters = queryParameters.set('applicationKey', <any>applicationKey);
        }
        if (numberOfAccounts !== undefined) {
            queryParameters = queryParameters.set('numberOfAccounts', <any>numberOfAccounts);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/xml',
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
        ];

        return this.httpClient.get<JsonNearNeighborAccount>(`${this.basePath}/nodeService/getNearNeighborAccounts`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * get nearest Node to latitude and longitude provided.
     * get nearest Node to latitude and longitude provided
     * @param latitude
     * @param longitude
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public resourceNodeServiceResourceGetNearestNodeGET(latitude?: number, longitude?: number, observe?: 'body', reportProgress?: boolean): Observable<JsonNodeProximityList>;
    public resourceNodeServiceResourceGetNearestNodeGET(latitude?: number, longitude?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<JsonNodeProximityList>>;
    public resourceNodeServiceResourceGetNearestNodeGET(latitude?: number, longitude?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<JsonNodeProximityList>>;
    public resourceNodeServiceResourceGetNearestNodeGET(latitude?: number, longitude?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (latitude !== undefined) {
            queryParameters = queryParameters.set('latitude', <any>latitude);
        }
        if (longitude !== undefined) {
            queryParameters = queryParameters.set('longitude', <any>longitude);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/xml',
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
        ];

        return this.httpClient.get<JsonNodeProximityList>(`${this.basePath}/nodeService/nearestNode`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param nodeAffinities
     * @param queryTimeout
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public resourceNodeServiceResourceGetNodeActiveEventCountStormModeAndThresholdsGET(nodeAffinities?: string, queryTimeout?: number, observe?: 'body', reportProgress?: boolean): Observable<JsonActiveEventCountStormModeAndThresholdResponse>;
    public resourceNodeServiceResourceGetNodeActiveEventCountStormModeAndThresholdsGET(nodeAffinities?: string, queryTimeout?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<JsonActiveEventCountStormModeAndThresholdResponse>>;
    public resourceNodeServiceResourceGetNodeActiveEventCountStormModeAndThresholdsGET(nodeAffinities?: string, queryTimeout?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<JsonActiveEventCountStormModeAndThresholdResponse>>;
    public resourceNodeServiceResourceGetNodeActiveEventCountStormModeAndThresholdsGET(nodeAffinities?: string, queryTimeout?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (nodeAffinities !== undefined) {
            queryParameters = queryParameters.set('nodeAffinities', <any>nodeAffinities);
        }
        if (queryTimeout !== undefined) {
            queryParameters = queryParameters.set('queryTimeout', <any>queryTimeout);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/xml',
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
        ];

        return this.httpClient.get<JsonActiveEventCountStormModeAndThresholdResponse>(`${this.basePath}/nodeService/getNodeActiveEventCountStormModeAndThresholds`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param cmts
     * @param node
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public resourceNodeServiceResourceGetNodeAffinityGET(cmts?: string, node?: string, observe?: 'body', reportProgress?: boolean): Observable<string>;
    public resourceNodeServiceResourceGetNodeAffinityGET(cmts?: string, node?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<string>>;
    public resourceNodeServiceResourceGetNodeAffinityGET(cmts?: string, node?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<string>>;
    public resourceNodeServiceResourceGetNodeAffinityGET(cmts?: string, node?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (cmts !== undefined) {
            queryParameters = queryParameters.set('cmts', <any>cmts);
        }
        if (node !== undefined) {
            queryParameters = queryParameters.set('node', <any>node);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/plain'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
        ];

        return this.httpClient.get<string>(`${this.basePath}/nodeService/getNodeAffinity`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * get all nodes within 1 mile of the lat/long provided.
     * get all nodes within 1 mile of the lat/long provided
     * @param latitude
     * @param longitude
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public resourceNodeServiceResourceGetNodeByProximityGET(latitude?: number, longitude?: number, observe?: 'body', reportProgress?: boolean): Observable<JsonNodeProximityList>;
    public resourceNodeServiceResourceGetNodeByProximityGET(latitude?: number, longitude?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<JsonNodeProximityList>>;
    public resourceNodeServiceResourceGetNodeByProximityGET(latitude?: number, longitude?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<JsonNodeProximityList>>;
    public resourceNodeServiceResourceGetNodeByProximityGET(latitude?: number, longitude?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (latitude !== undefined) {
            queryParameters = queryParameters.set('latitude', <any>latitude);
        }
        if (longitude !== undefined) {
            queryParameters = queryParameters.set('longitude', <any>longitude);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/xml',
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
        ];

        return this.httpClient.get<JsonNodeProximityList>(`${this.basePath}/nodeService/nodeByProximity`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * This WebMethod  will take a node id  and returns a list job id for the node.
     * This WebMethod  will take a node id  and returns a list job id for the node
     * @param nodeId nodeId
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public resourceNodeServiceResourceGetNodeJobIdsGET(nodeId?: number, observe?: 'body', reportProgress?: boolean): Observable<Array<JsonJobTsi>>;
    public resourceNodeServiceResourceGetNodeJobIdsGET(nodeId?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<JsonJobTsi>>>;
    public resourceNodeServiceResourceGetNodeJobIdsGET(nodeId?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<JsonJobTsi>>>;
    public resourceNodeServiceResourceGetNodeJobIdsGET(nodeId?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (nodeId !== undefined) {
            queryParameters = queryParameters.set('nodeId', <any>nodeId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/xml',
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
        ];

        return this.httpClient.get<Array<JsonJobTsi>>(`${this.basePath}/nodeService/getNodeJobIds`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Query to get logs entered by technicians for the node and logs of the jobs created for this node.
     * Query to get logs entered by technicians for the node and logs of the jobs created for this node
     * @param nodeid - network inventory id of the node
     * @param type - Job or Manual
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public resourceNodeServiceResourceGetNodeLogGET(nodeid?: number, type?: string, observe?: 'body', reportProgress?: boolean): Observable<JsonNodeLog>;
    public resourceNodeServiceResourceGetNodeLogGET(nodeid?: number, type?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<JsonNodeLog>>;
    public resourceNodeServiceResourceGetNodeLogGET(nodeid?: number, type?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<JsonNodeLog>>;
    public resourceNodeServiceResourceGetNodeLogGET(nodeid?: number, type?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (nodeid !== undefined) {
            queryParameters = queryParameters.set('nodeid', <any>nodeid);
        }
        if (type !== undefined) {
            queryParameters = queryParameters.set('type', <any>type);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/xml',
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
        ];

        return this.httpClient.get<JsonNodeLog>(`${this.basePath}/nodeService/getNodeLog`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param dateRange
     * @param node
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public resourceNodeServiceResourceGetNodeMoveHistoryGET(dateRange?: number, node?: string, observe?: 'body', reportProgress?: boolean): Observable<JsonNodeMoveHistory>;
    public resourceNodeServiceResourceGetNodeMoveHistoryGET(dateRange?: number, node?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<JsonNodeMoveHistory>>;
    public resourceNodeServiceResourceGetNodeMoveHistoryGET(dateRange?: number, node?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<JsonNodeMoveHistory>>;
    public resourceNodeServiceResourceGetNodeMoveHistoryGET(dateRange?: number, node?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (dateRange !== undefined) {
            queryParameters = queryParameters.set('dateRange', <any>dateRange);
        }
        if (node !== undefined) {
            queryParameters = queryParameters.set('node', <any>node);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/xml',
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
        ];

        return this.httpClient.get<JsonNodeMoveHistory>(`${this.basePath}/nodeService/getNodeMoveHistory`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * This method will return ND-ticket details related to one specific node.
     * This method will return ND-ticket details related to one specific node.
     * @param hierId
     * @param hierType
     * @param nodeId
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public resourceNodeServiceResourceGetNodeNDTicketsGET(hierId?: number, hierType?: string, nodeId?: number, observe?: 'body', reportProgress?: boolean): Observable<Array<JsonNodeNDTicket>>;
    public resourceNodeServiceResourceGetNodeNDTicketsGET(hierId?: number, hierType?: string, nodeId?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<JsonNodeNDTicket>>>;
    public resourceNodeServiceResourceGetNodeNDTicketsGET(hierId?: number, hierType?: string, nodeId?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<JsonNodeNDTicket>>>;
    public resourceNodeServiceResourceGetNodeNDTicketsGET(hierId?: number, hierType?: string, nodeId?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (hierId !== undefined) {
            queryParameters = queryParameters.set('hierId', <any>hierId);
        }
        if (hierType !== undefined) {
            queryParameters = queryParameters.set('hierType', <any>hierType);
        }
        if (nodeId !== undefined) {
            queryParameters = queryParameters.set('nodeId', <any>nodeId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/xml',
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
        ];

        return this.httpClient.get<Array<JsonNodeNDTicket>>(`${this.basePath}/nodeService/getNodeNDTickets`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param nodeid
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public resourceNodeServiceResourceGetNodeRepairLogCountGET(nodeid?: number, observe?: 'body', reportProgress?: boolean): Observable<string>;
    public resourceNodeServiceResourceGetNodeRepairLogCountGET(nodeid?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<string>>;
    public resourceNodeServiceResourceGetNodeRepairLogCountGET(nodeid?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<string>>;
    public resourceNodeServiceResourceGetNodeRepairLogCountGET(nodeid?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (nodeid !== undefined) {
            queryParameters = queryParameters.set('nodeid', <any>nodeid);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/plain'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
        ];

        return this.httpClient.get<string>(`${this.basePath}/nodeService/getNodeRepairLogCount`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param rtmId
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public resourceNodeServiceResourceGetNodeRepairLogInfoByIdGET(rtmId?: number, observe?: 'body', reportProgress?: boolean): Observable<JsonRTMRepairLogInfo>;
    public resourceNodeServiceResourceGetNodeRepairLogInfoByIdGET(rtmId?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<JsonRTMRepairLogInfo>>;
    public resourceNodeServiceResourceGetNodeRepairLogInfoByIdGET(rtmId?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<JsonRTMRepairLogInfo>>;
    public resourceNodeServiceResourceGetNodeRepairLogInfoByIdGET(rtmId?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (rtmId !== undefined) {
            queryParameters = queryParameters.set('rtmId', <any>rtmId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/xml',
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
        ];

        return this.httpClient.get<JsonRTMRepairLogInfo>(`${this.basePath}/nodeService/getNodeRepairLogInfoById`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Query to get repair logs for this node.
     * Query to get repair logs for this node
     * @param active - boolean - default true
     * @param applicationKey - For external systems
     * @param nodeid - network inventory id of the node
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public resourceNodeServiceResourceGetNodeRepairLogsGET(active?: boolean, applicationKey?: string, nodeid?: number, observe?: 'body', reportProgress?: boolean): Observable<Array<JsonRTMRepairLog>>;
    public resourceNodeServiceResourceGetNodeRepairLogsGET(active?: boolean, applicationKey?: string, nodeid?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<JsonRTMRepairLog>>>;
    public resourceNodeServiceResourceGetNodeRepairLogsGET(active?: boolean, applicationKey?: string, nodeid?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<JsonRTMRepairLog>>>;
    public resourceNodeServiceResourceGetNodeRepairLogsGET(active?: boolean, applicationKey?: string, nodeid?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (active !== undefined) {
            queryParameters = queryParameters.set('active', <any>active);
        }
        if (applicationKey !== undefined) {
            queryParameters = queryParameters.set('applicationKey', <any>applicationKey);
        }
        if (nodeid !== undefined) {
            queryParameters = queryParameters.set('nodeid', <any>nodeid);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/xml',
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
        ];

        return this.httpClient.get<Array<JsonRTMRepairLog>>(`${this.basePath}/nodeService/getNodeRepairLogs`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * This web method will return Schedule maintenance ticket details like ticket number , start time end date for a specific nodeId.
     * This web method will return Schedule maintenance ticket details like ticket number , start time end date for a specific nodeId
     * @param hierId
     * @param hierType
     * @param nodeId
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public resourceNodeServiceResourceGetNodeSMTicketsGET(hierId?: number, hierType?: string, nodeId?: number, observe?: 'body', reportProgress?: boolean): Observable<Array<JsonNodeSMTicket>>;
    public resourceNodeServiceResourceGetNodeSMTicketsGET(hierId?: number, hierType?: string, nodeId?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<JsonNodeSMTicket>>>;
    public resourceNodeServiceResourceGetNodeSMTicketsGET(hierId?: number, hierType?: string, nodeId?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<JsonNodeSMTicket>>>;
    public resourceNodeServiceResourceGetNodeSMTicketsGET(hierId?: number, hierType?: string, nodeId?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (hierId !== undefined) {
            queryParameters = queryParameters.set('hierId', <any>hierId);
        }
        if (hierType !== undefined) {
            queryParameters = queryParameters.set('hierType', <any>hierType);
        }
        if (nodeId !== undefined) {
            queryParameters = queryParameters.set('nodeId', <any>nodeId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/xml',
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
        ];

        return this.httpClient.get<Array<JsonNodeSMTicket>>(`${this.basePath}/nodeService/getNodeSMTickets`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param cmts
     * @param nodeId
     * @param nodeName
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public resourceNodeServiceResourceGetNodeScoreInfoGET(cmts?: string, nodeId?: number, nodeName?: string, observe?: 'body', reportProgress?: boolean): Observable<JsonNodeScoreInfo>;
    public resourceNodeServiceResourceGetNodeScoreInfoGET(cmts?: string, nodeId?: number, nodeName?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<JsonNodeScoreInfo>>;
    public resourceNodeServiceResourceGetNodeScoreInfoGET(cmts?: string, nodeId?: number, nodeName?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<JsonNodeScoreInfo>>;
    public resourceNodeServiceResourceGetNodeScoreInfoGET(cmts?: string, nodeId?: number, nodeName?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (cmts !== undefined) {
            queryParameters = queryParameters.set('cmts', <any>cmts);
        }
        if (nodeId !== undefined) {
            queryParameters = queryParameters.set('nodeId', <any>nodeId);
        }
        if (nodeName !== undefined) {
            queryParameters = queryParameters.set('nodeName', <any>nodeName);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/xml',
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
        ];

        return this.httpClient.get<JsonNodeScoreInfo>(`${this.basePath}/nodeService/getNodeScoreInfo`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param cmts
     * @param node
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public resourceNodeServiceResourceGetNodeTranspondersGET(cmts?: string, node?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<JsonExcludedTransponderInfo>>;
    public resourceNodeServiceResourceGetNodeTranspondersGET(cmts?: string, node?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<JsonExcludedTransponderInfo>>>;
    public resourceNodeServiceResourceGetNodeTranspondersGET(cmts?: string, node?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<JsonExcludedTransponderInfo>>>;
    public resourceNodeServiceResourceGetNodeTranspondersGET(cmts?: string, node?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (cmts !== undefined) {
            queryParameters = queryParameters.set('cmts', <any>cmts);
        }
        if (node !== undefined) {
            queryParameters = queryParameters.set('node', <any>node);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/xml',
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
        ];

        return this.httpClient.get<Array<JsonExcludedTransponderInfo>>(`${this.basePath}/nodeService/getNodeTransponders`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Gets the noise log list by node id.
     * Gets the noise log list by node id
     * @param nodeid is in long
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public resourceNodeServiceResourceGetNoiseLogByNodeGET(nodeid?: number, observe?: 'body', reportProgress?: boolean): Observable<Array<JsonNoiseLog>>;
    public resourceNodeServiceResourceGetNoiseLogByNodeGET(nodeid?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<JsonNoiseLog>>>;
    public resourceNodeServiceResourceGetNoiseLogByNodeGET(nodeid?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<JsonNoiseLog>>>;
    public resourceNodeServiceResourceGetNoiseLogByNodeGET(nodeid?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (nodeid !== undefined) {
            queryParameters = queryParameters.set('nodeid', <any>nodeid);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/xml',
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
        ];

        return this.httpClient.get<Array<JsonNoiseLog>>(`${this.basePath}/nodeService/getNoiseLogByNode`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * This WebMethod  will  returns a list of Menu.
     * This WebMethod  will  returns a list of Menu
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public resourceNodeServiceResourceGetQuickLaunchMenuGET(observe?: 'body', reportProgress?: boolean): Observable<Array<JsonMenuDTO>>;
    public resourceNodeServiceResourceGetQuickLaunchMenuGET(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<JsonMenuDTO>>>;
    public resourceNodeServiceResourceGetQuickLaunchMenuGET(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<JsonMenuDTO>>>;
    public resourceNodeServiceResourceGetQuickLaunchMenuGET(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/xml',
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
        ];

        return this.httpClient.get<Array<JsonMenuDTO>>(`${this.basePath}/nodeService/getQuickLaunchMenu`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param nodeId
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public resourceNodeServiceResourceGetSharedPowerSupplyForNodeGET(nodeId?: number, observe?: 'body', reportProgress?: boolean): Observable<JsonPoweredNode>;
    public resourceNodeServiceResourceGetSharedPowerSupplyForNodeGET(nodeId?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<JsonPoweredNode>>;
    public resourceNodeServiceResourceGetSharedPowerSupplyForNodeGET(nodeId?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<JsonPoweredNode>>;
    public resourceNodeServiceResourceGetSharedPowerSupplyForNodeGET(nodeId?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (nodeId !== undefined) {
            queryParameters = queryParameters.set('nodeId', <any>nodeId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/xml',
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
        ];

        return this.httpClient.get<JsonPoweredNode>(`${this.basePath}/nodeService/getSharedPowerSupplyForNode`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * This WebMethod  will take all node name  and cmts returns a list of Transponder.
     * This WebMethod  will take all node name  and cmts returns a list of Transponder
     * @param body
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public resourceNodeServiceResourceGetSubscriberForAllNodePOST(body?: JsonInputParam, observe?: 'body', reportProgress?: boolean): Observable<Array<JsonNodeSubscribersDTO>>;
    public resourceNodeServiceResourceGetSubscriberForAllNodePOST(body?: JsonInputParam, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<JsonNodeSubscribersDTO>>>;
    public resourceNodeServiceResourceGetSubscriberForAllNodePOST(body?: JsonInputParam, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<JsonNodeSubscribersDTO>>>;
    public resourceNodeServiceResourceGetSubscriberForAllNodePOST(body?: JsonInputParam, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/xml',
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/xml',
            'application/json'
        ];
        let httpContentTypeSelected:string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set("Content-Type", httpContentTypeSelected);
        }

        return this.httpClient.post<Array<JsonNodeSubscribersDTO>>(`${this.basePath}/nodeService/getSubscriberForAllNode`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param systemMapFtaId
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public resourceNodeServiceResourceGetSystemMapFtaIdGET(systemMapFtaId?: string, observe?: 'body', reportProgress?: boolean): Observable<JsonSystemMapFtaId>;
    public resourceNodeServiceResourceGetSystemMapFtaIdGET(systemMapFtaId?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<JsonSystemMapFtaId>>;
    public resourceNodeServiceResourceGetSystemMapFtaIdGET(systemMapFtaId?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<JsonSystemMapFtaId>>;
    public resourceNodeServiceResourceGetSystemMapFtaIdGET(systemMapFtaId?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (systemMapFtaId !== undefined) {
            queryParameters = queryParameters.set('systemMapFtaId', <any>systemMapFtaId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/xml',
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
        ];

        return this.httpClient.get<JsonSystemMapFtaId>(`${this.basePath}/nodeService/getSystemMapFtaId`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * This WebMethod  will  return List TSI Affected Accounts.
     * This WebMethod  will  return List TSI Affected Accounts
     * @param nodeId
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public resourceNodeServiceResourceGetTSIAccountsGET(nodeId?: number, observe?: 'body', reportProgress?: boolean): Observable<Array<JsonAccount>>;
    public resourceNodeServiceResourceGetTSIAccountsGET(nodeId?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<JsonAccount>>>;
    public resourceNodeServiceResourceGetTSIAccountsGET(nodeId?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<JsonAccount>>>;
    public resourceNodeServiceResourceGetTSIAccountsGET(nodeId?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (nodeId !== undefined) {
            queryParameters = queryParameters.set('nodeId', <any>nodeId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/xml',
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
        ];

        return this.httpClient.get<Array<JsonAccount>>(`${this.basePath}/nodeService/getTSIAccounts`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * This WebMethod  will take all node name  and cmts returns a list of Transponder.
     * This WebMethod  will take all node name  and cmts returns a list of Transponder
     * @param body
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public resourceNodeServiceResourceGetTransponderForAllNodePOST(body?: JsonInputParam, observe?: 'body', reportProgress?: boolean): Observable<Array<JsonNodeTransponderResponse>>;
    public resourceNodeServiceResourceGetTransponderForAllNodePOST(body?: JsonInputParam, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<JsonNodeTransponderResponse>>>;
    public resourceNodeServiceResourceGetTransponderForAllNodePOST(body?: JsonInputParam, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<JsonNodeTransponderResponse>>>;
    public resourceNodeServiceResourceGetTransponderForAllNodePOST(body?: JsonInputParam, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/xml',
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/xml',
            'application/json'
        ];
        let httpContentTypeSelected:string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set("Content-Type", httpContentTypeSelected);
        }

        return this.httpClient.post<Array<JsonNodeTransponderResponse>>(`${this.basePath}/nodeService/getTransponderForAllNode`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param cmts
     * @param endTime
     * @param node
     * @param size
     * @param startTime
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public resourceNodeServiceResourceGetTransponderPollHistoryByNodeForTimeLineGET(cmts?: string, endTime?: number, node?: string, size?: number, startTime?: number, observe?: 'body', reportProgress?: boolean): Observable<Array<JsonTransponderInfo>>;
    public resourceNodeServiceResourceGetTransponderPollHistoryByNodeForTimeLineGET(cmts?: string, endTime?: number, node?: string, size?: number, startTime?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<JsonTransponderInfo>>>;
    public resourceNodeServiceResourceGetTransponderPollHistoryByNodeForTimeLineGET(cmts?: string, endTime?: number, node?: string, size?: number, startTime?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<JsonTransponderInfo>>>;
    public resourceNodeServiceResourceGetTransponderPollHistoryByNodeForTimeLineGET(cmts?: string, endTime?: number, node?: string, size?: number, startTime?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (cmts !== undefined) {
            queryParameters = queryParameters.set('cmts', <any>cmts);
        }
        if (endTime !== undefined) {
            queryParameters = queryParameters.set('endTime', <any>endTime);
        }
        if (node !== undefined) {
            queryParameters = queryParameters.set('node', <any>node);
        }
        if (size !== undefined) {
            queryParameters = queryParameters.set('size', <any>size);
        }
        if (startTime !== undefined) {
            queryParameters = queryParameters.set('startTime', <any>startTime);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/xml',
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
        ];

        return this.httpClient.get<Array<JsonTransponderInfo>>(`${this.basePath}/nodeService/getTransponderPollHistoryByNodeForTimeLine`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param cmts
     * @param endTime
     * @param node
     * @param size
     * @param startTime
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public resourceNodeServiceResourceGetTransponderPollHistoryByNodeGET(cmts?: string, endTime?: number, node?: string, size?: number, startTime?: number, observe?: 'body', reportProgress?: boolean): Observable<Array<JsonTransponderInfo>>;
    public resourceNodeServiceResourceGetTransponderPollHistoryByNodeGET(cmts?: string, endTime?: number, node?: string, size?: number, startTime?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<JsonTransponderInfo>>>;
    public resourceNodeServiceResourceGetTransponderPollHistoryByNodeGET(cmts?: string, endTime?: number, node?: string, size?: number, startTime?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<JsonTransponderInfo>>>;
    public resourceNodeServiceResourceGetTransponderPollHistoryByNodeGET(cmts?: string, endTime?: number, node?: string, size?: number, startTime?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (cmts !== undefined) {
            queryParameters = queryParameters.set('cmts', <any>cmts);
        }
        if (endTime !== undefined) {
            queryParameters = queryParameters.set('endTime', <any>endTime);
        }
        if (node !== undefined) {
            queryParameters = queryParameters.set('node', <any>node);
        }
        if (size !== undefined) {
            queryParameters = queryParameters.set('size', <any>size);
        }
        if (startTime !== undefined) {
            queryParameters = queryParameters.set('startTime', <any>startTime);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/xml',
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
        ];

        return this.httpClient.get<Array<JsonTransponderInfo>>(`${this.basePath}/nodeService/getTransponderPollHistoryByNode`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param endTime
     * @param mac
     * @param size
     * @param startTime
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public resourceNodeServiceResourceGetTransponderPollHistoryGET(endTime?: number, mac?: string, size?: number, startTime?: number, observe?: 'body', reportProgress?: boolean): Observable<Array<JsonTransponderInfo>>;
    public resourceNodeServiceResourceGetTransponderPollHistoryGET(endTime?: number, mac?: string, size?: number, startTime?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<JsonTransponderInfo>>>;
    public resourceNodeServiceResourceGetTransponderPollHistoryGET(endTime?: number, mac?: string, size?: number, startTime?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<JsonTransponderInfo>>>;
    public resourceNodeServiceResourceGetTransponderPollHistoryGET(endTime?: number, mac?: string, size?: number, startTime?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (endTime !== undefined) {
            queryParameters = queryParameters.set('endTime', <any>endTime);
        }
        if (mac !== undefined) {
            queryParameters = queryParameters.set('mac', <any>mac);
        }
        if (size !== undefined) {
            queryParameters = queryParameters.set('size', <any>size);
        }
        if (startTime !== undefined) {
            queryParameters = queryParameters.set('startTime', <any>startTime);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/xml',
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
        ];

        return this.httpClient.get<Array<JsonTransponderInfo>>(`${this.basePath}/nodeService/getTransponderPollHistory`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * This web method will return an object of type TransponderInventory holding the source for a specific transponder mac address.
     * This web method will return an object of type TransponderInventory holding the source for a specific transponder mac address.
     * @param macAddress
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public resourceNodeServiceResourceGetTransponderSourceByMacGET(macAddress?: string, observe?: 'body', reportProgress?: boolean): Observable<JsonTransponderInventory>;
    public resourceNodeServiceResourceGetTransponderSourceByMacGET(macAddress?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<JsonTransponderInventory>>;
    public resourceNodeServiceResourceGetTransponderSourceByMacGET(macAddress?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<JsonTransponderInventory>>;
    public resourceNodeServiceResourceGetTransponderSourceByMacGET(macAddress?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (macAddress !== undefined) {
            queryParameters = queryParameters.set('macAddress', <any>macAddress);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/xml',
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
        ];

        return this.httpClient.get<JsonTransponderInventory>(`${this.basePath}/nodeService/getTransponderSourceByMac`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * This method return the transponder tracker url based on the environment.
     * This method return the transponder tracker url based on the environment
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public resourceNodeServiceResourceGetTransponderTrackerGET(observe?: 'body', reportProgress?: boolean): Observable<JsonTransponderTrackerResult>;
    public resourceNodeServiceResourceGetTransponderTrackerGET(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<JsonTransponderTrackerResult>>;
    public resourceNodeServiceResourceGetTransponderTrackerGET(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<JsonTransponderTrackerResult>>;
    public resourceNodeServiceResourceGetTransponderTrackerGET(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/xml',
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
        ];

        return this.httpClient.get<JsonTransponderTrackerResult>(`${this.basePath}/nodeService/getTransponderTracker`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * This method will return worst nodes details of some specific ncpNodes.
     * This method will return worst nodes details of some specific ncpNodes. This details are needed for the functionality &#39;make job&#39;.
     * @param ncpNodeId - Provides list of Selected Node Ids of type Long
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public resourceNodeServiceResourceGetWorstNodeDetailsGET(ncpNodeId?: Array<number>, observe?: 'body', reportProgress?: boolean): Observable<Array<JsonAutoTicketingInfo>>;
    public resourceNodeServiceResourceGetWorstNodeDetailsGET(ncpNodeId?: Array<number>, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<JsonAutoTicketingInfo>>>;
    public resourceNodeServiceResourceGetWorstNodeDetailsGET(ncpNodeId?: Array<number>, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<JsonAutoTicketingInfo>>>;
    public resourceNodeServiceResourceGetWorstNodeDetailsGET(ncpNodeId?: Array<number>, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (ncpNodeId) {
            ncpNodeId.forEach((element) => {
                queryParameters = queryParameters.append('ncpNodeId', <any>element);
            })
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/xml',
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
        ];

        return this.httpClient.get<Array<JsonAutoTicketingInfo>>(`${this.basePath}/nodeService/getWorstNodeDetails`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * This method will return the list of all worst nodes under a specific Parent Hub with specific start and end date.
     * This method will return the list of all worst nodes under a specific Parent Hub with specific start and end date
     * @param dftId - dftId of the network hierarchy
     * @param endDate - start date to capture the node behavior
     * @param order
     * @param sortId
     * @param startDate - start date to capture the node behavior
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public resourceNodeServiceResourceGetWorstNodesGET(dftId?: number, endDate?: number, order?: string, sortId?: string, startDate?: number, observe?: 'body', reportProgress?: boolean): Observable<Array<JsonWorstNode>>;
    public resourceNodeServiceResourceGetWorstNodesGET(dftId?: number, endDate?: number, order?: string, sortId?: string, startDate?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<JsonWorstNode>>>;
    public resourceNodeServiceResourceGetWorstNodesGET(dftId?: number, endDate?: number, order?: string, sortId?: string, startDate?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<JsonWorstNode>>>;
    public resourceNodeServiceResourceGetWorstNodesGET(dftId?: number, endDate?: number, order?: string, sortId?: string, startDate?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (dftId !== undefined) {
            queryParameters = queryParameters.set('dftId', <any>dftId);
        }
        if (endDate !== undefined) {
            queryParameters = queryParameters.set('endDate', <any>endDate);
        }
        if (order !== undefined) {
            queryParameters = queryParameters.set('order', <any>order);
        }
        if (sortId !== undefined) {
            queryParameters = queryParameters.set('sortId', <any>sortId);
        }
        if (startDate !== undefined) {
            queryParameters = queryParameters.set('startDate', <any>startDate);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/xml',
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
        ];

        return this.httpClient.get<Array<JsonWorstNode>>(`${this.basePath}/nodeService/getWorstNodes`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Gets the hierarchy Id by node id.
     * Gets the hierarchy Id by node id
     * @param nodeid is in long
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public resourceNodeServiceResourceGethierarchyIdByNodeGET(nodeid?: number, observe?: 'body', reportProgress?: boolean): Observable<number>;
    public resourceNodeServiceResourceGethierarchyIdByNodeGET(nodeid?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<number>>;
    public resourceNodeServiceResourceGethierarchyIdByNodeGET(nodeid?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<number>>;
    public resourceNodeServiceResourceGethierarchyIdByNodeGET(nodeid?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (nodeid !== undefined) {
            queryParameters = queryParameters.set('nodeid', <any>nodeid);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/xml',
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
        ];

        return this.httpClient.get<number>(`${this.basePath}/nodeService/gethierarchyIdByNode`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public resourceNodeServiceResourceImportSystemMapFtaIdGET(observe?: 'body', reportProgress?: boolean): Observable<string>;
    public resourceNodeServiceResourceImportSystemMapFtaIdGET(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<string>>;
    public resourceNodeServiceResourceImportSystemMapFtaIdGET(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<string>>;
    public resourceNodeServiceResourceImportSystemMapFtaIdGET(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/xml',
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
        ];

        return this.httpClient.get<string>(`${this.basePath}/nodeService/importSystemMapFtaId`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param body
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public resourceNodeServiceResourceIncludeTransponderPOST(body?: string, observe?: 'body', reportProgress?: boolean): Observable<number>;
    public resourceNodeServiceResourceIncludeTransponderPOST(body?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<number>>;
    public resourceNodeServiceResourceIncludeTransponderPOST(body?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<number>>;
    public resourceNodeServiceResourceIncludeTransponderPOST(body?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/xml',
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/xml',
            'application/json'
        ];
        let httpContentTypeSelected:string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set("Content-Type", httpContentTypeSelected);
        }

        return this.httpClient.post<number>(`${this.basePath}/nodeService/includeTransponder`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * This service will take an account number and return a list of mac addresses for the account.
     * This service will take an account number and return a list of mac addresses for the account
     * @param account account number
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public resourceNodeServiceResourceMacsByAccountGET(account?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<string>>;
    public resourceNodeServiceResourceMacsByAccountGET(account?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<string>>>;
    public resourceNodeServiceResourceMacsByAccountGET(account?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<string>>>;
    public resourceNodeServiceResourceMacsByAccountGET(account?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (account !== undefined) {
            queryParameters = queryParameters.set('account', <any>account);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/xml',
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
        ];

        return this.httpClient.get<Array<string>>(`${this.basePath}/nodeService/macsByAccount`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * This method will return the node details of the specific account number.
     * This method will return the node details of the specific account number
     * @param accountNum is the passed parameter in string format
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public resourceNodeServiceResourceNodeByAccountGET(accountNum?: string, observe?: 'body', reportProgress?: boolean): Observable<JsonAdvancedSearchResult>;
    public resourceNodeServiceResourceNodeByAccountGET(accountNum?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<JsonAdvancedSearchResult>>;
    public resourceNodeServiceResourceNodeByAccountGET(accountNum?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<JsonAdvancedSearchResult>>;
    public resourceNodeServiceResourceNodeByAccountGET(accountNum?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (accountNum !== undefined) {
            queryParameters = queryParameters.set('accountNum', <any>accountNum);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/xml',
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
        ];

        return this.httpClient.get<JsonAdvancedSearchResult>(`${this.basePath}/nodeService/nodeByAccount`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * This method will return the node details of the specific account number.
     * This method will return the node details of the specific account number
     * @param mac
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public resourceNodeServiceResourceNodeByMacGET(mac?: string, observe?: 'body', reportProgress?: boolean): Observable<JsonAdvancedSearchResult>;
    public resourceNodeServiceResourceNodeByMacGET(mac?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<JsonAdvancedSearchResult>>;
    public resourceNodeServiceResourceNodeByMacGET(mac?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<JsonAdvancedSearchResult>>;
    public resourceNodeServiceResourceNodeByMacGET(mac?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (mac !== undefined) {
            queryParameters = queryParameters.set('mac', <any>mac);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/xml',
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
        ];

        return this.httpClient.get<JsonAdvancedSearchResult>(`${this.basePath}/nodeService/nodeByMac`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param body
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public resourceNodeServiceResourcePersistTransponderPollResultsPOST(body?: Array<JsonTransponderInfo>, observe?: 'body', reportProgress?: boolean): Observable<JsonBaseResponseDTO>;
    public resourceNodeServiceResourcePersistTransponderPollResultsPOST(body?: Array<JsonTransponderInfo>, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<JsonBaseResponseDTO>>;
    public resourceNodeServiceResourcePersistTransponderPollResultsPOST(body?: Array<JsonTransponderInfo>, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<JsonBaseResponseDTO>>;
    public resourceNodeServiceResourcePersistTransponderPollResultsPOST(body?: Array<JsonTransponderInfo>, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/xml',
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/xml',
            'application/json'
        ];
        let httpContentTypeSelected:string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set("Content-Type", httpContentTypeSelected);
        }

        return this.httpClient.post<JsonBaseResponseDTO>(`${this.basePath}/nodeService/persistTransponderPollResults`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param cmts
     * @param node
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public resourceNodeServiceResourcePollByNodeCmtsGET(cmts?: string, node?: string, observe?: 'body', reportProgress?: boolean): Observable<string>;
    public resourceNodeServiceResourcePollByNodeCmtsGET(cmts?: string, node?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<string>>;
    public resourceNodeServiceResourcePollByNodeCmtsGET(cmts?: string, node?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<string>>;
    public resourceNodeServiceResourcePollByNodeCmtsGET(cmts?: string, node?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (cmts !== undefined) {
            queryParameters = queryParameters.set('cmts', <any>cmts);
        }
        if (node !== undefined) {
            queryParameters = queryParameters.set('node', <any>node);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/plain'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
        ];

        return this.httpClient.get<string>(`${this.basePath}/nodeService/pollByNodeCmts`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param body
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public resourceNodeServiceResourcePostSystemMapFtaIdsPOST(body?: Array<JsonSystemMapFtaId>, observe?: 'body', reportProgress?: boolean): Observable<string>;
    public resourceNodeServiceResourcePostSystemMapFtaIdsPOST(body?: Array<JsonSystemMapFtaId>, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<string>>;
    public resourceNodeServiceResourcePostSystemMapFtaIdsPOST(body?: Array<JsonSystemMapFtaId>, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<string>>;
    public resourceNodeServiceResourcePostSystemMapFtaIdsPOST(body?: Array<JsonSystemMapFtaId>, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/xml',
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/xml',
            'application/json'
        ];
        let httpContentTypeSelected:string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set("Content-Type", httpContentTypeSelected);
        }

        return this.httpClient.post<string>(`${this.basePath}/nodeService/postSystemMapFtaIds`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param limit
     * @param phoneNumber
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public resourceNodeServiceResourceRemoveBadPhoneNumbersGET(limit?: number, phoneNumber?: string, observe?: 'body', reportProgress?: boolean): Observable<JsonBaseResponseDTO>;
    public resourceNodeServiceResourceRemoveBadPhoneNumbersGET(limit?: number, phoneNumber?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<JsonBaseResponseDTO>>;
    public resourceNodeServiceResourceRemoveBadPhoneNumbersGET(limit?: number, phoneNumber?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<JsonBaseResponseDTO>>;
    public resourceNodeServiceResourceRemoveBadPhoneNumbersGET(limit?: number, phoneNumber?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (limit !== undefined) {
            queryParameters = queryParameters.set('limit', <any>limit);
        }
        if (phoneNumber !== undefined) {
            queryParameters = queryParameters.set('phoneNumber', <any>phoneNumber);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/plain'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
        ];

        return this.httpClient.get<JsonBaseResponseDTO>(`${this.basePath}/nodeService/removeBadPhoneNumbers`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Removes noise log.
     * Removes noise log
     * @param body
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public resourceNodeServiceResourceRemoveNoiseLogPOST(body?: JsonNoiseLog, observe?: 'body', reportProgress?: boolean): Observable<Array<JsonNoiseLog>>;
    public resourceNodeServiceResourceRemoveNoiseLogPOST(body?: JsonNoiseLog, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<JsonNoiseLog>>>;
    public resourceNodeServiceResourceRemoveNoiseLogPOST(body?: JsonNoiseLog, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<JsonNoiseLog>>>;
    public resourceNodeServiceResourceRemoveNoiseLogPOST(body?: JsonNoiseLog, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/xml',
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/xml',
            'application/json'
        ];
        let httpContentTypeSelected:string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set("Content-Type", httpContentTypeSelected);
        }

        return this.httpClient.post<Array<JsonNoiseLog>>(`${this.basePath}/nodeService/removeNoiseLog`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * This method will reset the last refresh times of docsis and auto ticket schemes so that configuration data will be refreshed next time.
     * This method will reset the last refresh times of docsis and auto ticket schemes so that configuration data will be refreshed next time.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public resourceNodeServiceResourceResetLastRefreshTimesGET(observe?: 'body', reportProgress?: boolean): Observable<JsonBaseResponseDTO>;
    public resourceNodeServiceResourceResetLastRefreshTimesGET(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<JsonBaseResponseDTO>>;
    public resourceNodeServiceResourceResetLastRefreshTimesGET(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<JsonBaseResponseDTO>>;
    public resourceNodeServiceResourceResetLastRefreshTimesGET(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/xml',
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
        ];

        return this.httpClient.get<JsonBaseResponseDTO>(`${this.basePath}/nodeService/resetLastRefreshTimes`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * This WebMethod  will  save TSI Affected Accounts.
     * This WebMethod  will  save TSI Affected Accounts
     * @param body
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public resourceNodeServiceResourceSaveTSIAccountsPOST(body?: JsonSaveTSIAffectedAccountsReq, observe?: 'body', reportProgress?: boolean): Observable<JsonBaseResponseDTO>;
    public resourceNodeServiceResourceSaveTSIAccountsPOST(body?: JsonSaveTSIAffectedAccountsReq, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<JsonBaseResponseDTO>>;
    public resourceNodeServiceResourceSaveTSIAccountsPOST(body?: JsonSaveTSIAffectedAccountsReq, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<JsonBaseResponseDTO>>;
    public resourceNodeServiceResourceSaveTSIAccountsPOST(body?: JsonSaveTSIAffectedAccountsReq, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/xml',
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/xml',
            'application/json'
        ];
        let httpContentTypeSelected:string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set("Content-Type", httpContentTypeSelected);
        }

        return this.httpClient.post<JsonBaseResponseDTO>(`${this.basePath}/nodeService/saveTSIAccounts`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param text
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public resourceNodeServiceResourceSearchAccountGET(text?: string, observe?: 'body', reportProgress?: boolean): Observable<JsonAccountList>;
    public resourceNodeServiceResourceSearchAccountGET(text?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<JsonAccountList>>;
    public resourceNodeServiceResourceSearchAccountGET(text?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<JsonAccountList>>;
    public resourceNodeServiceResourceSearchAccountGET(text?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (text !== undefined) {
            queryParameters = queryParameters.set('text', <any>text);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/xml',
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
        ];

        return this.httpClient.get<JsonAccountList>(`${this.basePath}/nodeService/searchAccount`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
    /**
     *
     *
     * @param searchText
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public resourceNodeServiceResourceSearchCMTSGET(searchText?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<string>>;
    public resourceNodeServiceResourceSearchCMTSGET(searchText?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<string>>>;
    public resourceNodeServiceResourceSearchCMTSGET(searchText?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<string>>>;
    public resourceNodeServiceResourceSearchCMTSGET(searchText?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (searchText !== undefined) {
            queryParameters = queryParameters.set('searchText', <any>searchText);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/xml',
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
        ];

        return this.httpClient.get<Array<string>>(`${this.basePath}/nodeService/searchCMTS`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * This service will take any string and do an hbase scan to find any related nodes Scans for Node names, mac addresses, housekeys, and account numbers.
     * This service will take any string and do an hbase scan to find any related nodes Scans for Node names, mac addresses, housekeys, and account numbers
     * @param text node, mac, housekey, account number (can be partial, case sensitive)
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public resourceNodeServiceResourceSearchNodeGET(text?: string, observe?: 'body', reportProgress?: boolean): Observable<JsonNodeSearchResultsList>;
    public resourceNodeServiceResourceSearchNodeGET(text?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<JsonNodeSearchResultsList>>;
    public resourceNodeServiceResourceSearchNodeGET(text?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<JsonNodeSearchResultsList>>;
    public resourceNodeServiceResourceSearchNodeGET(text?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (text !== undefined) {
            queryParameters = queryParameters.set('text', <any>text);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/xml',
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
        ];

        return this.httpClient.get<JsonNodeSearchResultsList>(`${this.basePath}/nodeService/searchNode`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param manual
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public resourceNodeServiceResourceSynchronizeTransponderDataGET(manual?: string, observe?: 'body', reportProgress?: boolean): Observable<JsonBaseResponseDTO>;
    public resourceNodeServiceResourceSynchronizeTransponderDataGET(manual?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<JsonBaseResponseDTO>>;
    public resourceNodeServiceResourceSynchronizeTransponderDataGET(manual?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<JsonBaseResponseDTO>>;
    public resourceNodeServiceResourceSynchronizeTransponderDataGET(manual?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (manual !== undefined) {
            queryParameters = queryParameters.set('manual', <any>manual);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/plain'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
        ];

        return this.httpClient.get<JsonBaseResponseDTO>(`${this.basePath}/nodeService/synchronizeTransponderData`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param causeSolution
     * @param rtmId
     * @param userId
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public resourceNodeServiceResourceUpdateRepairLogCompletionDetailsGET(causeSolution?: string, rtmId?: number, userId?: number, observe?: 'body', reportProgress?: boolean): Observable<JsonBaseResponseDTO>;
    public resourceNodeServiceResourceUpdateRepairLogCompletionDetailsGET(causeSolution?: string, rtmId?: number, userId?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<JsonBaseResponseDTO>>;
    public resourceNodeServiceResourceUpdateRepairLogCompletionDetailsGET(causeSolution?: string, rtmId?: number, userId?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<JsonBaseResponseDTO>>;
    public resourceNodeServiceResourceUpdateRepairLogCompletionDetailsGET(causeSolution?: string, rtmId?: number, userId?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (causeSolution !== undefined) {
            queryParameters = queryParameters.set('causeSolution', <any>causeSolution);
        }
        if (rtmId !== undefined) {
            queryParameters = queryParameters.set('rtmId', <any>rtmId);
        }
        if (userId !== undefined) {
            queryParameters = queryParameters.set('userId', <any>userId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/plain'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
        ];

        return this.httpClient.get<JsonBaseResponseDTO>(`${this.basePath}/nodeService/updateRepairLogCompletionDetails`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
